export default __webpack_public_path__ + "static/media/Newsletter_w.71657fa6.svg";